import { useBrand } from '../context/BrandContext';
import FastestFormCRMLayout from './fastestform/CRMLayout';
import AbleCRMLayout from './able/CRMLayout';

export default function CRMLayout() {
  const { brand } = useBrand();
  return brand === 'able' ? <AbleCRMLayout /> : <FastestFormCRMLayout />;
}
